import { WebHaptics } from 'web-haptics';

let instance: WebHaptics | null = null;

function getHaptics(): WebHaptics | null {
	if (typeof window === 'undefined') return null;
	if (!instance) instance = new WebHaptics();
	return instance;
}

export type HapticPreset = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'selection';

export function haptic(preset: HapticPreset): void {
	getHaptics()?.trigger(preset);
}
